import { theme } from "styles/mui-config";
import styled from "styled-components";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { Typography } from "@mui/material";

export const StyledPaper = styled(Paper)`
  padding: 20px;
  border-radius: 15px !important;
  margin-bottom: 30px;
  & div > div {
    border-radius: 15px !important;
  }
`;

export const StyledButton = styled(Button)`
  padding-right: 48px !important;
  padding-left: 48px !important;
  border-radius: 15px !important;
`;

export const StyledDivButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 20px;
`;

export const StyledDivIcon = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 15px !important;
  color: ${theme.palette.primary.dark};
  background: #03baea17;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

export const StyledDivtext = styled.div`
  display: inline-flex;
  flex-direction: column;
  padding-right: 10px;
  font-size: 15px;
  & h4 {
    margin: 0;
    color: ${theme.palette.primary.dark};
    margin-bottom: 3px;
  }
  & p {
    margin: 0;
    color: #939393;
  }
  & p > a{
    margin: 0;
    color: #939393;
  }
`;

export const StyledH3Title = styled.h3`
  color: #939393;
  font-weight: normal;
  font-size: 1.1428571428571428rem;
  margin-top: 9px;
  margin-bottom: 9px;
`;

export const StyledGrid = styled(Grid)`
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  min-height: 400px;
`;

export const StyledLink = styled(Link)`
  color: rgb(0, 32, 46);
  margin-right: 20px;
`;

export const StyledTitle = styled(Typography)`
  position: relative;
  font-size: 20px !important;
  color: ${theme.palette.primary.dark};
  font-weight: bolder !important;
  top: -4px;
  text-align: center;
  padding-top: 20px;

  &::before {
    content: "";
    position: absolute;
    right: 50%;
    left: 50%;
    top: 0px;
    width: 100px;
    border: 3px solid ${theme.palette.primary.dark};
    border-radius: 1px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    pointer-events: none;
    transform: translate(50%);
  }
`;
